module.exports = __webpack_public_path__ + "img/window-L.5c404ecf.svg";